import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';

import * as Styled from './InfoWidget.styled';

const InfoWidget = (props) => {
  const {
    classes,
    className,
    title,
    actionButton,
    children,
    contentLoader,
    isLoading,
    collapsible,
    open,
  } = props;

  const [isOpen, setIsOpen] = useState(open);

  return (
    <Styled.RootComponent
      className={classnames(classes.root, className)}
      collapsible={collapsible}
      isOpen={isOpen}>
      {isLoading ? (
        <>{contentLoader ? contentLoader : '...'}</>
      ) : (
        <>
          <Styled.HeaderContainer
            className={classes.header}
            collapsible={collapsible}
            isOpen={isOpen}
            onClick={() => (collapsible ? setIsOpen(!isOpen) : undefined)}>
            <Styled.TitleContainer className={classes.title}>
              {title}
            </Styled.TitleContainer>
            {actionButton && (
              <Styled.ButtonContainer className={classes.actionButtonContainer}>
                {actionButton}
              </Styled.ButtonContainer>
            )}
            {collapsible && (
              <Styled.CollapsibleButtonContainer>
                {isOpen ? <ExpandLess /> : <ExpandMore />}
              </Styled.CollapsibleButtonContainer>
            )}
          </Styled.HeaderContainer>
          {collapsible ? (
            isOpen ? (
              <Styled.BodyContainer>{children}</Styled.BodyContainer>
            ) : null
          ) : (
            <Styled.BodyContainer>{children}</Styled.BodyContainer>
          )}
        </>
      )}
    </Styled.RootComponent>
  );
};

InfoWidget.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
    title: PropTypes.string,
    actionButtonContainer: PropTypes.string,
    body: PropTypes.string,
    header: PropTypes.string,
  }),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  actionButton: PropTypes.node,
  contentLoader: PropTypes.node,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  isLoading: PropTypes.bool,
  collapsible: PropTypes.bool,
  open: PropTypes.bool,
};

InfoWidget.defaultProps = {
  className: '',
  classes: {
    root: '',
    title: '',
    actionButton: '',
    body: '',
    header: '',
  },
  title: '',
  actionButton: null,
  contentLoader: null,
  isLoading: false,
  collapsible: false,
  open: true,
};

export default InfoWidget;
